<template>
  <svg
    id="flag-icon-css-de"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    :height="height"
  >
    <g fill-rule="evenodd">
      <path fill="#981e32" d="M0 0h640v192H0z" />
      <path fill="#fff" d="M0 192h640v96H0z" />
      <path fill="#981e32" d="M0 288h640v192H0z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LvFlag',
  props: {
    height: {
      type: String,
      default: '20px'
    }
  }
}
</script>
